import { useRouteMatch } from 'react-router-dom';
import type { IRouterParams } from '../../app/router-utils';

const useGetIssuerShortname = (): string | undefined => {
  // We have to use useRouteMatch instead of useParams because useGetIssuerShortname may be called
  // in a component that is not a child of a <Route>, in which case useParams whon't work.
  // https://github.com/remix-run/react-router/issues/7026#issuecomment-552582981
  const match = useRouteMatch<IRouterParams>('/:ticker');
  const shortnameFromRouterParams = match?.params.ticker;

  // Otherwise, try pulling it from the URL from useParams:
  return shortnameFromRouterParams
    ? shortnameFromRouterParams.toLowerCase()
    : shortnameFromRouterParams;
};

export default useGetIssuerShortname;
